/* Shibi V3.2 — up-sell panier : ajoute le produit puis recharge le tiroir panier (ou la page panier). */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-shibi-upsell]');
  if (!button || button.disabled) return;
  const box = button.closest('.su');
  const error = box && box.querySelector('.su__error');
  const drawer = button.dataset.context === 'drawer' && document.querySelector('cart-drawer');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: Number(button.dataset.shibiUpsell), quantity: 1 }],
      sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined,
      sections_url: window.location.pathname
    })
  })
    .then((response) => response.json().then((json) => {
      if (!response.ok) throw new Error(json.description || json.message || '');
      return json;
    }))
    .then((state) => {
      if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
        drawer.renderContents(state);
        document.dispatchEvent(new CustomEvent('shibi:upsell-added'));
      } else {
        window.location.reload();
      }
    })
    .catch((err) => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (error) {
        error.textContent = err.message || 'Ce produit n\'a pas pu être ajouté. Réessayez.';
        error.hidden = false;
      }
    });
});
  
